import axios from "axios";
import {
  Zap, Power, Wifi, Smartphone, ShieldCheck, GraduationCap, Tv, Landmark, Home, Receipt,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("reewards_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n, symbol = "$") =>
  `${symbol}${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

export const ICONS = { Zap, Power, Wifi, Smartphone, ShieldCheck, GraduationCap, Tv, Landmark, Home, Receipt };
export const catIcon = (name) => ICONS[name] || Receipt;

export default api;
